module.exports = __webpack_public_path__ + "static/media/banner-homepage2.46ac18eb.jpg";